<template>
  <div
    :class="[
      'content d-flex items-center',
      { 'is-checkable': isCheckable },
      { 'is-editable': isEditable },
      { 'is-vertical': VERTICAL_TEMPLATES[content.templateId] },
    ]"
  >
    <button
      class="move-detail-button-area d-flex justify-between items-center"
      @click="clickContentDetail"
    >
      <JaContentPreview
        class="content-preview"
        :processNum="CREATE_CONTENT_PROCESS_NUM.CONTENT_LIST_PREVIEW"
        :templateId="content.templateId"
        :contentMaterialList="content.contentMaterialList"
        :contentCaption="content.contentCaption"
        :contentCaptionColor="content.contentCaptionColor"
        :contentFrame="content.contentFrameDto"
        :isEditing="false"
      />
    </button>
    <div class="content-description d-flex items-center">
      <div class="d-flex items-center justify-between">
        <label class="content-duration-label">
          <div
            class="content-duration d-flex items-center"
            v-if="
              (isCheckable && content.contentDuration) ||
              ((!isCheckable || isEditable) && content.isIncludeMovie)
            "
          >
            <img :src="VIDEO_ICON" alt="video icon" />
            <span class="duration">{{ convertSecTommss(content.contentDuration) }}</span>
          </div>
          <div
            v-else-if="!isCheckable"
            class="content-duration d-flex items-center"
            style="margin-left: auto"
          >
            <img :src="IMAGE_ICON" :class="{ grayscale: !isEditable }" alt="image icon" />
            <select
              v-if="isEditable"
              id="imageDuration"
              :value="content.contentDuration"
              @change="(e) => setContentDuration(content.contentId, e.target.value)"
            >
              <option v-for="d in IMAGE_DURATIONS" :value="d.value" :key="d.text">
                {{ d.text }}
              </option>
            </select>
            <span v-else class="duration">
              {{ convertSecTommss(content.contentDuration) }}
            </span>
          </div>
        </label>
      </div>
      <div v-if="isEditable" class="handle d-flex justify-center items-center">
        <img :src="CONTENT_DRAG_ICON" alt="icon drag image" />
      </div>
    </div>
    <div v-if="!isEditable" class="d-flex justify-between items-center position-relative">
      <Button
        v-if="isCheckable"
        :class="[
          'check-button non-check',
          {
            checked: selectedContentList.some((sel) => sel.contentId === content.contentId),
          },
        ]"
      >
        <v-ons-icon icon="fa-check" class="check-icon" />
      </Button>
      <Button @click="() => checkContent(content)" class="transparent-check-button"></Button>
    </div>
  </div>
</template>

<script setup>
import { VERTICAL_TEMPLATES, CREATE_CONTENT_PROCESS_NUM } from '@/composable/constant_common';
import { convertSecTommss } from '@/composable/material_common';
import { useRouter } from 'vue-router';

import Button from '@/components/common/Button.vue';
import CONTENT_DRAG_ICON from '@/assets/images/IconContentDrag.svg';
import VIDEO_ICON from '@/assets/images/IconStreamGroupDuration.png';
import IMAGE_ICON from '@/assets/images/IconImage.svg';
import JaContentPreview from '../JaContent/JaContentPreview.vue';

const router = useRouter();
// Props定義
const props = defineProps({
  content: { type: Object, default: () => ({}) },
  selectedContentList: { type: Array, default: () => [] },
  checkContent: { type: Function, default: () => {} },
  setContentDuration: { type: Function, default: () => {} },
  isCheckable: { type: Boolean, default: false },
  isEditable: { type: Boolean, default: false },
});

// 画像再生秒数設定値
const IMAGE_DURATIONS = [
  { text: '00:05', value: 5 },
  { text: '00:10', value: 10 },
  { text: '00:20', value: 20 },
  { text: '00:30', value: 30 },
];

const clickContentDetail = () => {
  if (!props.isEditable) {
    router.push({
      name: 'ja-content-detail',
      params: { contentId: props.content.contentId },
    });
  }
};
</script>

<style scoped>
.content {
  width: 100%;
  border-bottom: 0.1rem solid #ddd;
  position: relative;
}
.content:first-child {
  border-top: 0.1rem solid #ddd;
}
.move-detail-button-area {
  background-color: white;
  border: none;
  width: 85%;
  height: 100%;
  padding: 0;
}
.content-preview {
  flex-shrink: 0;
  height: 10rem;
  width: calc(10rem * (16 / 9));
}
.is-vertical .content-preview {
  height: 10rem;
  width: calc(10rem * (9 / 16));
  padding-left: 2rem;
  padding-right: 2rem;
}
.content-description {
  flex-grow: 1;
  justify-content: end;
  padding-left: 1rem;
}
.content-img {
  width: 6rem;
  height: 4rem;
  padding: 2rem 0.7rem 2rem 1.7rem;
}
.content-img > img {
  object-fit: cover;
  width: 6rem;
  height: 4rem;
}
.is-editable .content-duration {
  width: 8rem;
}
.duration {
  font-size: 1.4rem;
  color: #aaa;
  padding-left: 0.5rem;
}
.grayscale {
  filter: gray;
  -webkit-filter: grayscale(1);
}
.move-button-area {
  width: 4.5rem;
}
.play-icon {
  background-color: #fff;
  color: #aaa;
  font-size: 3vmin;
}
.check-button {
  width: 25px;
  height: 25px;
  border-radius: 50%;
}
.transparent-check-button {
  width: 100px;
  height: 100px;
  background: transparent;
  position: relative;
}
.transparent-check-button:active {
  background: transparent;
}
.non-check {
  border: 2px solid#aaa;
  background: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.checked {
  background-color: #21963b;
  border: 2px solid#21963b;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.padding-check-button {
  padding: 20px;
}
.check-icon {
  color: #fff;
  font-size: 1.5rem;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  position: absolute;
}
.handle {
  width: 4rem;
  height: 8rem;
  margin-inline: 0.5rem;
}
.content-duration-label {
  padding-left: 1.5rem;
}
select {
  border: none;
  padding-left: 0.5rem;
  font-size: 1.4rem;
  height: 8rem;
  text-decoration: underline;
  color: #21963b;
  box-sizing: border-box;
  background-color: transparent;
}
.sortable-chosen {
  opacity: 0.7;
  background-color: #dcdcdc;
}
.sortable-ghost {
  background-color: #dcdcdc;
}
.position-relative {
  position: relative;
}
.visiable-button {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #21963b;
  border: 2px solid#21963b;
}
</style>
